export const AccuWeatherMock = {
  imageAltText: 'AccuWeather Logo',
  selectPositioning: 'nearbyAccuweather',
  ':type': 'mi-aem-ppv5-spa/components/content/accuWeather',
  weatherForecast: 'Weather Forecast',
  daysWeatherForecast: 5,
  showAccuWeatherInL1: true,
  daysOfWeek: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  accuWeatherImage:
    'https://cache.marriott.com/content/dam/marriott-digital/mcomppv5/global/en_us/logo/assets/pdt-AccuWeather-Logo-168720693221076.png',
};

export const AccuWeatherHeaderMock = {
  imageAltText: 'AccuWeather Logo',
  selectPositioning: 'headerAccuweather',
  ':type': 'mi-aem-ppv5-spa/components/content/accuWeather',
  weatherForecast: 'Weather Forecast',
  daysWeatherForecast: 1,
  showAccuWeatherInL1: true,
  daysOfWeek: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  accuWeatherImage:
    'https://cache.marriott.com/content/dam/marriott-digital/mcomppv5/global/en_us/logo/assets/pdt-AccuWeather-Logo-168720693221076.png',
};

//create the date
const addDays = (days: number): string => {
  const now = new Date();
  now.setDate(now.getDate() + days);
  return now.toISOString().slice(0, 19) + '-05:00';
};

export const AccuWeatherMockUXL = {
  property: {
    __typename: 'Hotel',
    weather: {
      __typename: 'PropertyWeather',
      hourly: [
        {
          __typename: 'HourlyWeatherDetail',
          dateTime: addDays(0),
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/hourly-weather-forecast/2627514?day=1&hbhhour=3&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/hourly-weather-forecast/2627514?day=1&hbhhour=3&lang=en-us',
          temperature: {
            __typename: 'Temperature',
            unit: 'F',
            value: 34,
          },
          weatherIcon: 36,
        },
      ],
      tenDay: [
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(0),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 6,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 36,
            },
          },
        },
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(1),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 3,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=1&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=1&lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 41,
            },
          },
        },
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(2),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 3,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=2&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=2&lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 36,
            },
          },
        },
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(3),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 4,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=3&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=3&lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 37,
            },
          },
        },
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(4),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 3,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=4&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=4&lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 46,
            },
          },
        },
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(5),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 29,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=5&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=5&lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 42,
            },
          },
        },
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(6),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 4,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=6&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=6&lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 44,
            },
          },
        },
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(7),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 2,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=7&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=7&lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 47,
            },
          },
        },
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(8),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 7,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=8&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=8&lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 49,
            },
          },
        },
        {
          __typename: 'HotelWeatherDailyForecast',
          date: addDays(9),
          day: {
            __typename: 'HotelWeatherDailyForecastDetails',
            weatherIcon: 2,
          },
          link: 'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=9&lang=en-us',
          mobileLink:
            'http://www.accuweather.com/en/us/theater-district-ny/10036/daily-weather-forecast/2627514?day=9&lang=en-us',
          temperature: {
            __typename: 'HotelWeatherDailyTemperature',
            maximum: {
              __typename: 'Temperature',
              unit: 'F',
              value: 51,
            },
          },
        },
      ],
    },
  },
};

export const mockPageParamContext = {
  preProcessorResponse: {
    userSegment: 'NOT Logged In',
    validMarsha: true,
    status: 'SUCCESS',
    message: '',
    statusCode: '200',
    brandCode: 'MC',
    experienceSegment: 'Connected-Unknown-Tier1-Guest',
    locale: 'en-US',
    subDirectory: 'en-US',
    currentStateMapping: {
      title: 'tier1Title',
      welcomeText: 'welcomeText',
      description: 'unknownConnectedDescription',
      isConnectState: false,
      connectUpgradeBtn: 'upgradeButtonLabel',
      signInButton: {
        signInButtonLink: '',
        signInButtonLabel: '',
        signInButtonLinkInNewTab: '',
      },
      joinNowButton: {
        joinButtonLabel: 'joinButtonLabel',
        joinButtonLink: 'joinButtonLink',
        joinButtonLinkInNewTab: 'joinButtonLinkInNewTab',
      },
      termsAndConditions: 'termsAndConditions',
      signInText: '',
      noLoginInterfaceModal: false,
      showLoginModal: false,
      loginModal: {
        default: false,
        separatorLabel: false,
        userAccessCodeLabel: false,
        requestAccessCodeLabel: false,
        errorMessage: false,
        connectNowLabel: false,
      },
      showAccessModal: false,
      accessModal: {
        default: false,
        acErrorMessage: false,
      },
      showReqAccessModal: false,
      reqAccessModal: {
        default: false,
        racErrorMessage: false,
      },
      showUpgradeGenErr: false,
      showUpgradeLRErr: false,
      showUpgradeMaxErr: false,
      showUpgradeNoCCErr: false,
      showUpgradePMSErr: false,
      showUpgradeSuccessNAInfo: false,
      showUpgradeSuccessMAXInfo: false,
      showPricingModal: false,
      showUpgradeModal: false,
    },
    cna: false,
    mac: false,
    sameTab: true,
    marsha: 'nycmq',
    state: 'connected',
    userState: 'unknown',
    cookie: 'sessionID=0E8AAD48-4931-5F2E-808A-BB1F0A8B89BF',
  },
  sessionID: '',
  requestId: '/einterface/v5/nycmq~X~694F9E51-9538-556F-AF11-D009CB1F4061',
  lang: 'en-US',
};
